import React from "react"
import Join from "./join"

function Screen6() {
  return (
    <div className='screen6'>
      <div className="contribute">
        <h1 className='contribute-h1'>Become a contributor?</h1>
        <p className='contribute-txt'>
          Join us and get tips & tricks to become a great
          <br />
          Designer and Developer
        </p>
      </div>
      <Join />
    </div>
  )
}

export default Screen6
